import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixin from '@/mixin'
import VueClipboard from 'vue-clipboard2'

import './styles/app.less'
import './plugins'
import './permission'


import errorHandler from './errorHandler'
import globalComponents from './components'

Vue.config.productionTip = false
Vue.config.errorHandler = errorHandler

Object.keys(globalComponents).forEach((name) =>
    Vue.component(name, globalComponents[name])
)

Vue.use(VueClipboard)
Vue.mixin(mixin)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
